module.exports = __webpack_public_path__ + "img/profess5.af37e5ca.png";